//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, func, string } from 'prop-types'
import copyIcon from 'images/sheet.png'
import MenuOption from './MenuOption'

const CopyProject = props => {
  const {
    hasHighlighted,
    idRoot,
    setModalTemplate,
  } = props

  return (
    <MenuOption
      enabled={hasHighlighted}
      icon={copyIcon}
      id={`${idRoot}copy-projects`}
      label={'Copy Project'}
      modalTemplate={'copy-projects'}
      setModalTemplate={setModalTemplate} />
  )
}

CopyProject.propTypes = {
  hasHighlighted: bool.isRequired,
  idRoot: string.isRequired,
  setModalTemplate: func.isRequired,
}

export default CopyProject
